import { useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { FaGooglePlay, FaApple } from "react-icons/fa";
import { CSSTransition } from "react-transition-group";
import Button from "../components/Button";
import IconText from "../components/IconText";
import { createGlobalStyle } from "styled-components";

const DownloadAppDropDown = () => {
  const dropDownRef = useRef(null);
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const cssTransitionProps = {
    timeout: 500,
    nodeRef: dropDownRef,
    in: dropDownOpen,
    classNames: "drop-down",
    unmountOnExit: true,
  };

  const handleOpen = () => setDropDownOpen((prevValue) => !prevValue);
  return (
    <>
      <CSSTransitionClassNames />
      <div className="download">
        <div className="relative shrink-0">
          <Button rest={{ onClick: handleOpen }}>
            <div className="flex items-center flex-auto justify-between">
              <span className="uppercase mr-2">Download Gepzo App</span>
              <span
                className={`transition-all duration-300 ${
                  dropDownOpen ? "rotate-180" : ""
                }`}
              >
                <IoIosArrowDown />
              </span>
            </div>
          </Button>
          <CSSTransition {...cssTransitionProps}>
            <div
              ref={dropDownRef}
              className="absolute bg-white rounded-md border top-full text-[#c34532] w-full text-sm font-normal rounded-b shadow-md transition-all overflow-hidden duration-300"
            >
              <a
                href="#"
                className="flex py-3 px-4 hover:bg-[#e7f0f7] transition-all duration-300"
              >
                <IconText
                  textInfo={{ text: "Google Play", classes: "uppercase" }}
                  iconInfo={{ Icon: FaGooglePlay, classes: "h-5 w-5 mr-2" }}
                  iconFirst
                />
              </a>
              <a
                href="#"
                className="flex py-3 px-4 hover:bg-[#e7f0f7] transition-all duration-300"
              >
                <IconText
                  textInfo={{ text: "Apple Store", classes: "uppercase" }}
                  iconInfo={{ Icon: FaApple, classes: "h-5 w-5" }}
                  iconFirst
                />
              </a>
            </div>
          </CSSTransition>
        </div>
      </div>
    </>
  );
};

const CSSTransitionClassNames = createGlobalStyle`
    .drop-down-enter {
        opacity: 0;
        transform: translateY(-10px);
    }
    .drop-down-enter-active {
        opacity: 1;
        transform: translateY(5px);
        transition: opacity 400ms, transform 400ms;
    }
    .drop-down-enter-done {
        opacity: 1;
        transform: translateY(5px);
    }
    .drop-down-exit {
        opacity: 1;
        transform: translateY(5px);
    }
    .drop-down-exit-active {
        opacity: 0;
        transform: translateY(0px);
        transition: opacity 400ms, transform 400ms;
    }
    .drop-down-exit-done {
        opacity: 0;
    }
  `;

export default DownloadAppDropDown;
